// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Select, Skeleton, Text } from '@mantine/core';
import { FC, useEffect, useMemo, useState } from 'react';
import { IconExternalLink, IconFileEuro } from '@tabler/icons';
import { useNavigate } from 'react-router-dom';
import { closeAllModals } from '@mantine/modals';
import { i18n } from '@lingui/core';
import { PublishInvoiceConfigDTO, WorkflowConfigProps } from '../../../../../Types/LogT';
import { DataS } from '../../../../../Service/DataS';
import { WorkflowS } from '../../../../../Service/WorkflowS';
import { Profile } from '../../../../../Service/ProfileS';
import { useJwtClaims } from '../../../../../Service/Context/AuthContext';
import { AuthS } from '../../../../../Service/restapi/authService';
import LinkText from '../../../../../Atoms/LinkText';

const PublishInvoiceConfig: FC<WorkflowConfigProps> = ({ config, handleChange, availableEntities }) => {
  const { entityReference } = config as PublishInvoiceConfigDTO;
  const navigate = useNavigate();
  const [profile, setProfile] = useState<Profile>();
  const [loading, setLoading] = useState(false);
  const { profileId } = useJwtClaims();
  const availableDocuments = useMemo(
    () => WorkflowS.filterEntities(availableEntities, ['documents']),
    [availableEntities],
  );

  useEffect(() => {
    if (profileId) {
      setLoading(true);
      AuthS.fetchProfile(profileId)
        .then((resp) => {
          if (resp.ok) {
            resp.json().then(setProfile);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [profileId]);

  const { accountingTool } = profile ?? {};

  const openSettings = () => {
    closeAllModals();
    navigate('/settings/bookkeeping');
  };

  if (loading) {
    return <Skeleton width="100%" height={100} />;
  }

  if (profile && !accountingTool) {
    return (
      <Text align="center" my="xl">
        Für Ihr Konto ist anscheinend kein Buchhaltungstool konfiguriert. Bitte richten Sie das Buchhaltungstool ein, um
        fortfahren zu können.{' '}
        <LinkText span onClick={openSettings}>
          <IconExternalLink size={14} style={{ marginBottom: 2 }} /> Jetzt konfigurieren
        </LinkText>
      </Text>
    );
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {accountingTool && (
        <>
          <Select disabled label="Buchhaltung" data={DataS.getAccountingWebsiteOptions(i18n)} value={accountingTool} />
          <LinkText size="xs" mb="xs" onClick={openSettings}>
            <IconExternalLink size={14} style={{ marginBottom: 2 }} /> Jetzt konfigurieren
          </LinkText>
        </>
      )}
      <Select
        required
        mb="md"
        nothingFound="Keine Rechnungen. Du musst vorher im Workflow eine Rechnung erstellen."
        defaultValue={entityReference ? entityReference.id : null}
        icon={<IconFileEuro size={20} />}
        label="Rechnung"
        data={DataS.getEntityReferencesOptions(availableDocuments)}
        onChange={(val) => val && handleChange({ entityReferenceId: val })}
      />
    </>
  );
};

export default PublishInvoiceConfig;
